import FormValidator from 'utils/form-validator';

export default () => {
  // Init form validator
  new FormValidator(document.getElementById('contact_form'));
};
